import React from 'react';
import {connect} from 'react-redux';
import {BaseComponent as Component} from 'BaseComponent';
import Const from 'constants';
import RemoveStackItem from './remove-stack-item';

class Stacks extends Component {
    isAnyPlayerAbsentInStackItem(stackItem) {
        const {players} = this.props;

        if (!players.getPlayer(stackItem.keyPlayers[0] ?? '')) {
            return true;
        }

        for (let playerId of stackItem.selectedPlayers) {
            if (!players.getPlayer(playerId)) {
                return true;
            }
        }

        return false;
    }

    getStackLabel(stackItem) {
        const {players} = this.props;
        const player = players.getPlayer(stackItem.keyPlayers[0] ?? '');

        let str = `Stack `;
        if (player) {
            str += `${player.name} `;
        }

        str += `with `;

        if (stackItem.type === Const.STACKS_TYPE_AT_LEAST) {
            str += `no less than `;
        } else if (stackItem.type === Const.STACKS_TYPE_EXACTLY) {
            str += `exactly `;
        } else if (stackItem.type === Const.STACKS_TYPE_AT_MOST) {
            str += `no more than `;
        }

        str += `${stackItem.numberPlayers} `;

        const playersName = stackItem.selectedPlayers.map((playerId) => {
            const player = players.getPlayer(playerId);

            if (player) {
                return player.name;
            }
        });

        if (!isEmpty(playersName)) {
            str += ` ${playersName.join(', ')}`;
        }

        return str;
    }

    render() {
        const {stacking} = this.props;
        const items = stacking.getItems();

        return (
            <div className="advanced-tags">
                {Object.values(items).map((item) => {
                    return this.isAnyPlayerAbsentInStackItem(item) ? null : (
                        <span key={item.getId()} className="advanced-tag">
                            {this.getStackLabel(item)}
                            <RemoveStackItem itemId={item.getId()} />
                        </span>
                    );
                })}
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {playerNameStacking, playersData} = state;

    return {
        stacking: playerNameStacking,
        players: playersData.players,
    };
}

export default connect(mapStatesToProps)(Stacks);
